/**
 * API returns all offers in one bunch.
 *
 * Sort them into groups by date they were created.
 */
export const sortOffersByDate = (offers) => {
  const sortedOffers = new Map()

  offers.forEach((offer) => {
    const dateKey = offer.date_created
    if (sortedOffers.has(dateKey)) {
      const newSet = [...sortedOffers.get(dateKey), offer]
      sortedOffers.set(dateKey, newSet)
    } else {
      sortedOffers.set(dateKey, [offer])
    }
  })

  return sortedOffers
}

export default {
  sortOffersByDate,
}
